import * as React from 'react';
import autobind from 'autobind-decorator';
import { resolve } from 'inversify-react';
import { observable } from 'mobx';
import { observer } from 'mobx-react';
import { connect } from "react-redux";
import { Dispatch } from 'redux';

import { CardController } from 'src/app/shared/card.controller';
import { ContractsMarketView } from './contract-market.view';
import { ToastNotifications } from 'src/core/ui/toast';
import { ObjectUtils } from 'src/core/utils/object';
import { ContractMarketDataService } from 'src/app/products/contract/form/contract-market-form.data';
import { actionCreators } from "src/store/products/product-form-nav-actions";

interface PropsFromState {
	markets: ContractMarketItem[];
}

interface PropsFromDispatch {
	marketsLoaded: (contractItem: ContractItem, markets: ContractMarketItem[]) => any;
}

interface Props extends ComponentViewProps<ContractItem> {
	mode: ControlMode;
	onModeChanged: (mode: ControlMode) => void;
	contextService: any;
}

@observer
class ContractsMarketController extends React.Component<Props & PropsFromDispatch & PropsFromState, {}> {
	@observable
	protected dataService: ContractMarketDataService;

	@resolve
	protected toast: ToastNotifications;

	constructor(props) {
		super(props);
		this.dataService = ContractMarketDataService.make(this.props.contextService);
	}

	componentDidMount() {
		if (this.props.model.id && (this.props.markets == null)) {
			this.props.setBusy(true);
			this.dataService.addFilter('contractId', 'eq', this.props.model.id);
			this.dataService.addSorting('id', 'asc', true);
			this.dataService.pageSize = 20;
			this.dataService.load(query => query)
				.then((items) => {
					this.props.marketsLoaded(this.props.model, items.slice());
					this.props.setBusy(false);
				})
				.catch((error) => {
					this.props.setBusy(false);
					this.toast.showToast('Request failed', ObjectUtils.parseError(error), 'error');
				});
		} else {
			this.dataService.items = this.props.markets;
		}
	}

	@autobind
	private createNew() {
		return this.dataService.create(() => this.dataService.add(this.props.model.id))
			.then((market) => {
				this.props.marketsLoaded(this.props.model, [market]);
				this.props.setBusy(false);
				return market;
			})
			.catch((error) => {
				this.props.setBusy(false);
				this.toast.showToast('Request failed', ObjectUtils.parseError(error), 'error');
			});
	}

	render() {
		if (this.dataService == null || this.dataService.items == null) {
			return null;
		}

		return (
			<CardController
				icon="shop"
				title="Markets"
				mode={this.props.mode}
				className="card-borderless"
			>
				<ContractsMarketView
					mode={this.props.mode}
					model={this.dataService}
					setBusy={this.props.setBusy}
					createNew={this.createNew}
					afterDeleteItem={this.afterDelete}
				/>
			</CardController>
		);
	}

	private afterDelete = (items: ContractMarketItem[]) => {
		for (const item of items) {
			this.props.model.markets.splice(this.props.model.markets.findIndex(e => e.id == item.id), 1);
		}
		const obj: CostItem = this.props.model.dynamicProperties.price;
		obj.elements = obj.elements.filter(e => items.every(m => m.marketId != e.market));
	}
}

const mapStateToProps = (
	state: IApplicationState,
	props: ComponentViewProps<ContractItem>
): PropsFromState => {
	const contract = state.otherLoadedEntities.find(e => e.entity == props.model.entity) as ContractItem;
	return {
		markets: contract.markets,
	};
};

const mapDispatchToProps = (dispatch: Dispatch): PropsFromDispatch => ({
	marketsLoaded: (
		contract: ContractItem,
		markets: ContractMarketItem[],
	) => dispatch(actionCreators.productFormRelationshipLoaded(contract, markets, "markets")),
});

const connected = connect(mapStateToProps, mapDispatchToProps)(ContractsMarketController);
export { connected as ContractsMarketController };



// WEBPACK FOOTER //
// ./src/app/products/contract/form/parts/contract-market.controller.tsx